<!--
  Иконка базы данных: несколько слоев данных
  Используется в блоках просмотра сырых данных трекера
-->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <ellipse
      cx="12"
      cy="6"
      rx="7"
      ry="3"
      :stroke="stroke"
      stroke-width="2"
    />
    <path
      d="M5 6V12C5 13.66 8.13 15 12 15C15.87 15 19 13.66 19 12V6"
      :stroke="stroke"
      stroke-width="2"
    />
    <path
      d="M5 12V18C5 19.66 8.13 21 12 21C15.87 21 19 19.66 19 18V12"
      :stroke="stroke"
      stroke-width="2"
    />
    <path
      d="M5 12C5 13.66 8.13 15 12 15C15.87 15 19 13.66 19 12"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  name: "DataSourceIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
